import { useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";

import {
	CompletedTravelPage,
	ExtractPage,
	HomePage,
	LoginPage,
	NewTravelPage,
	PendingPaymentPage,
	ProfilePage,
	RetrievePasswordPage,
	ScheduledTravelPage,
	TravelListingPage,
	UpsertBankAccountPage,
	UpsertDriverPage,
	UpsertVehiclePage
} from "pages";

import { ProviderLayout, SingleLayout } from "layouts";
import ChangePasswordPage from "pages/change-password";
import PasswordRecoveryPage from "pages/password-recovery";
import SuccessPage from "pages/registration/success";
import CanceledTravelPage from "pages/travels/canceled-travel";
import MessagesPage from "pages/travels/message";
import {
	CompleteRegistrationRoute,
	IncompleteRegistrationRoute
} from "./private-route";
import RegistrationRoutes from "./registration";

function Routers() {
	const { pathname } = useLocation();

	useEffect(() => {
		setTimeout(() => {
			window.scrollTo({
				top: 0,
				left: 0,
				behavior: "smooth"
			});
		}, 100);
	}, [pathname]);

	return (
		<Routes>
			<Route path="/" element={<Navigate to="/perfil" replace />} />
			<Route path="/login" element={<LoginPage />} />
			<Route path="/reenviar-senha/" element={<RetrievePasswordPage />} />
			<Route
				path="/password-recovery/:token"
				element={<PasswordRecoveryPage />}
			/>
			<Route path="/alterar-senha" element={<ChangePasswordPage />} />

			<Route path="/cadastro" element={<SingleLayout />}>
				{RegistrationRoutes()}
			</Route>
			<Route path="/cadastro/veiculos/novo" element={<UpsertVehiclePage />} />
			<Route
				path="/cadastro/veiculos/:vehicleId/editar"
				element={<UpsertVehiclePage />}
			/>
			<Route path="/cadastro/motoristas/novo" element={<UpsertDriverPage />} />
			<Route
				path="/cadastro/motoristas/:driverId/editar"
				element={<UpsertDriverPage />}
			/>
			<Route path="/cadastro/contas/novo" element={<UpsertBankAccountPage />} />
			<Route
				path="/cadastro/contas/:bankAccountId/editar"
				element={<UpsertBankAccountPage />}
			/>
			<Route path="/cadastro/finalizado" element={<SuccessPage />} />

			<Route path="/viagens/:tripId/nova-viagem" element={<NewTravelPage />} />
			<Route
				path="/viagens/:tripId/pagamento-pendente"
				element={<PendingPaymentPage />}
			/>
			<Route
				path="/viagens/:tripId/agendada"
				element={<ScheduledTravelPage />}
			/>
			<Route
				path="/viagens/:tripId/finalizada"
				element={<CompletedTravelPage />}
			/>
			<Route
				path="/viagens/:tripId/cancelada"
				element={<CanceledTravelPage />}
			/>
			<Route path="/viagens/:tripId/mensagens" element={<MessagesPage />} />

			<Route path="" element={<ProviderLayout />}>
				<Route path="/home" element={<HomePage />} />
				<Route path="/viagens" element={<TravelListingPage />} />
				<Route path="/extrato" element={<ExtractPage />} />
				<Route path="/perfil" element={<ProfilePage />} />
			</Route>

			<Route
				element={
					<IncompleteRegistrationRoute
						fallbackRoute="/dashboard"
						publicFallbackRoute="/login"
					/>
				}
			/>

			<Route
				element={
					<CompleteRegistrationRoute
						fallbackRoute="/cadastro/informacoes-pessoais"
						publicFallbackRoute="/login"
					/>
				}
			/>

			<Route path="/*" element={<Navigate to="/" />} />
		</Routes>
	);
}

export default Routers;
